import { atom } from 'jotai/vanilla';
import type { GroupLicensePermissionType } from 'balus-common';

export const groupLicensePermissionsAtom = atom<GroupLicensePermissionType | null>(null);
